import { IWebBridgeCallable, registerWebBridge } from './bridge'
import { TransifyOptions, registerTransifyOptions } from './transify'

export * from './transify'

export const UFSdk = {
  init: ({
    transifyOptions,
    webBridge
  }: {
    transifyOptions: TransifyOptions
    webBridge: IWebBridgeCallable
  }) => {
    registerTransifyOptions(transifyOptions)
    registerWebBridge(webBridge)
  }
}
